import styled from 'styled-components';

export const Body = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding-bottom: 8px;
	flex: 1 1 auto;
	min-height: 0;
	overflow-y: auto;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const SectionLabel = styled.div`
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const SegmentedControl = styled.div`
	display: flex;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	overflow: hidden;
	background: ${({ theme }) => theme.gray[0]};
`;

export const SegmentButton = styled.button<{ active?: boolean }>`
	flex: 1;
	padding: 10px 14px;
	border: none;
	background: ${({ theme, active }) => (active ? theme.blue[300] : 'transparent')};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
	font-weight: ${({ active }) => (active ? 600 : 400)};

	&:not(:last-child) {
		border-right: 1px solid ${({ theme }) => theme.gray[200]};
	}

	&:hover {
		background: ${({ theme, active }) => (active ? theme.blue[300] : theme.gray[100])};
	}
`;

export const InfoBanner = styled.div`
	padding: 10px 14px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	background: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
`;

export const RadioGrid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

// Tinted container for secondary configuration sitting below the primary card grid.
// Groups one-or-more controls so the area reads as "options" without a heading.
export const OptionsGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 14px;
	border-radius: 8px;
	background: ${({ theme }) => theme.gray[100]};
`;

export const HelperText = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const CustomFrameworkInput = styled.input`
	box-sizing: border-box;
	width: 100%;
	padding: 8px 10px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	background: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;

export const CustomFrameworkInstructions = styled.textarea`
	box-sizing: border-box;
	width: 100%;
	min-height: 96px;
	padding: 8px 10px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	background: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
	font-family: inherit;
	line-height: 1.5;
	resize: vertical;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;
